import React, { useState } from "react";
import { useSelector } from "react-redux";
import ShiftsTable from "../Card/MaterEntryCards/ShiftsTable";
import ShiftsCard from "../Card/MaterEntryCards/ShiftsCard";
import CardHeadMenu from "../Card/CardHeadMenu/CardHeadMenu";

//FUNCTION
const Shifts = () => {
    //#region code
    const { is_super, is_admin } = useSelector((state) => state.GlobalVariables);
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState({});
    const [isCreate, setIsCreate] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const handleEdit = (data) => {
        setEditData(data);
        setIsCreate(true);
        setIsEdit(true);
    };

    const handlePopup = () => {
        setIsCreate(!isCreate);
    };
    //#endregion

    return (
        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"SHIFTS"}
                handlePopup={handlePopup}
                isEdit={isEdit}
                create={isCreate}
                showCreate={Boolean(is_super || is_admin)}
            />
            {isCreate && (
                <ShiftsCard
                    isChanged={isChanged}
                    setIsChanged={setIsChanged}
                    editData={editData}
                    setEditData={setEditData}
                />
            )}
            <ShiftsTable isChanged={isChanged} handleEdit={handleEdit} />
        </>
    );
};
export default Shifts;
